import { getManureTypeColor, IManureStock, labels, StockType } from "../omnia";
import { StockVm } from "./stockVm";


export class ManureStockVm extends StockVm {

    constructor(private manure: IManureStock) {
        super(manure, StockType.Manure);
    }

    get icon(): string {
        return "stock-manure";
    }

    hasProduct(): boolean {
        return !!this.manure;
    }

    getImgUrl(): string {
        var icon = this.manure.ManureType.Icon || "Factory";
        return "/images/stocks/" + icon + ".svg";
    }

    getColor(): number[] {
        let type = this.manure.ManureType;
        if (type) {
            return getManureTypeColor(type.InvariantId);
        }
    }

    getTooltip(): string {
        return this.manure.ManureType.Name;
    }

    getUnits() {

        if (this.manure.ManureType) {
            return labels.ManureUnit(this.manure.ManureType.Unit)
        }

    }

    getRoundingFactor(): number {
        return 10;
    }

}
